import React, { memo } from 'react'
import { graphql } from 'gatsby'

import PageLayout from '~layouts/PageLayout'
import Head from '~components/Head'
import Page from '~components/Page'

import './_fields'

const MarkdownPage = ({
  data, pageContext
}) => (
  <PageLayout alignment='full'>
    <Head title={pageContext.title} />
    <></>
    <Page page={data.page} hideTitle hideSource hideLinks />
    <></>
  </PageLayout>
)

export default memo(MarkdownPage)

export const query = graphql`
  query($id: String!) {
    page: markdownRemark(id: {
      eq: $id
    }) {
      ...pageFields
    }
  }
`
